import React from 'react';
import { X } from '@phosphor-icons/react';

import type { ContextPill } from './types';

interface ContextPillBadgeProps {
  pill: ContextPill;
  onRemove?: (pill: ContextPill) => void;
}

export const ContextPillBadge = ({ pill, onRemove }: ContextPillBadgeProps) => {
  return (
    <span className="inline-flex items-center gap-0.5 rounded-full bg-muted px-2 py-1 text-xs text-muted-foreground">
      {pill.label}
      {onRemove && (
        <button
          type="button"
          className="ml-0.5 inline-flex h-3.5 w-3.5 items-center justify-center rounded-full hover:bg-muted-foreground/20"
          onClick={() => onRemove(pill)}
        >
          <X className="h-2.5 w-2.5" />
        </button>
      )}
    </span>
  );
};
